import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { MyAccountService } from "../my-account.service";
import * as CryptoJS from "crypto-js";
import { BaseService } from "src/app/base/base.service";
import { MyProfileComponent } from "../my-profile/my-profile.component";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  data: any = { name: "", mobile_number: "", email: "", image: "" };
  constructor(
    private router: Router,
    private profileService: MyAccountService,
    private baseService: BaseService,
    private toastr: ToastrService,
    public myProfileComponent: MyProfileComponent
  ) { }
  url: any;
  socialMediaUser: boolean;

  ngOnInit(): void {
    if (localStorage.getItem(environment.localStorageKey)) {
      const encrypted_data = localStorage.getItem(environment.localStorageKey);
      const data = JSON.parse(
        CryptoJS.AES.decrypt(encrypted_data, environment.secretkey).toString(
          CryptoJS.enc.Utf8
        )
      );

      this.socialMediaUser = data.socialMediaUser;
      this.data = data;
    }
    // this.profileService.getProfile().subscribe(
    //   (res) => {
    //     this.data = res;
    //
    //   },
    //   (err) => {
    //     if (err.status === 0) {
    //       this.toastr.error("CONNECTION REFUSED", "Whoops!");
    //     } else if (err.status === 500) {
    //       this.toastr.error(err.statusText, "Whoops!");
    //     } else if (err.status === 404) {
    //       this.toastr.error(err.statusText, "Whoops!");
    //     } else if (err.status === 401) {
    //       this.toastr.error(err.statusText, "Whoops!");
    //     } else {
    //       this.toastr.error(err.statusText, "Whoops!");
    //     }
    //   }
    // );
  }
  errorHandler(event) {
    event.target.src = environment.userNoImage;
  }
  logOut() {
    this.baseService.logout().subscribe(
      (res) => {
        if (res) {
          localStorage.removeItem(environment.localStorageKey);
          localStorage.removeItem("user_info");
          this.router.navigate(["/"]);
        }

      }
    );
  }
  open() {
    this.profileService.isActive = true;
  }

  getClass() {
    return "active";
  }
}
